import { CreditSummary, OfferBanner } from '../../models';
import {
  callToActionMocks,
  links,
  offerImage
} from '../offer-detail/content.mocks';

export const creditSummary: CreditSummary = {
  statementCredit: '-$200.00',
  statementCreditLabel: 'AMEX Statement Credit*',
  totalLabel: 'Total After Statement Credit',
  total: {
    multiUnit: false,
    cash: {
      value: '80',
      fraction: '.00',
      symbol: '$',
      code: 'USD'
    },
    miles: {
      value: 0,
      code: 'USD'
    }
  }
};

export const revenueDiscountCreditSummary: CreditSummary = {
  statementCredit: '-2,000 miles',
  statementCreditLabel: 'AMEX Statement Credit*',
  totalLabel: 'Total After Statement Credit',
  total: {
    multiUnit: false,
    cash: {
      value: '350',
      fraction: '.00',
      symbol: '$',
      code: 'USD'
    },
    miles: {
      value: '19,000',
      code: 'USD'
    }
  }
};

export const congratsBanner: OfferBanner = {
  action: callToActionMocks,
  benefit: 'Plus enjoy your first checked bag free on Delta Flights',
  headline:
    'Congrats on the Delta SkyMiles<sup>&#174;</sup> Gold American Express Card',
  image: offerImage,
  offer: 'Earn a $200 Statement Credit and 20,000 Bonus Miles*',
  pageId: 'trip-summary-rev',
  summary: creditSummary,
  annualFee: '$0 introductory annual fee for the first year, then $95',
  details:
    '*Statement credit issued approximately 8-12 weeks after you make a Delta purchase on your Card in your first 3 months. Bonus miles will be issued after you make $1,000 in purchases on your new Card in your first 3 months. Terms and Conditions Apply.',
  links
};
